module.exports = __webpack_public_path__ + "front/img/p3.9fc8a10c.png";